export const transpose = array =>
  array[0].map((_, colIndex) => array.map(row => row[colIndex]));

export const clamp = (val, min, max) => Math.min(Math.max(val, min), max);
